module.exports = __webpack_public_path__ + "img/orderCart.3d1d6bee.svg";